module.exports = __webpack_public_path__ + "img/SA Certificate (Blank)_page-0001 (2).6c6bb779.jpg";